export default __webpack_public_path__ + "static/media/109 main cover.4e9bbb4e.jpg";